// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_fx","advertDetailContactItem__link":"c-m_fy","advertDetailContactItem__stub":"c-m_fz"};